import { render } from "./Galeria.vue?vue&type=template&id=e81829ac&scoped=true"
import script from "./Galeria.vue?vue&type=script&lang=js"
export * from "./Galeria.vue?vue&type=script&lang=js"

import "./Galeria.vue?vue&type=style&index=0&id=e81829ac&scoped=true&lang=css"

import exportComponent from "D:\\fitbar\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e81829ac"]])

export default __exports__